import {
  Component,
  EventEmitter,
  Injectable,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import {
  DateRange,
  MatDateRangeSelectionStrategy,
  MAT_DATE_RANGE_SELECTION_STRATEGY,
} from '@angular/material/datepicker';

import * as moment from 'moment';

@Injectable()
export class WeekRangeSelectionStrategy<D>
  implements MatDateRangeSelectionStrategy<D>
{
  constructor(private _dateAdapter: DateAdapter<D>) {}

  selectionFinished(date: D | null): DateRange<D> {
    return this.createWeekRange(date);
  }

  createPreview(activeDate: D | null): DateRange<D> {
    return this.createWeekRange(activeDate);
  }

  private createWeekRange(date: any | null): DateRange<D> {
    if (date) {
      const start = date.clone().startOf('isoWeek');
      const end = date.endOf('isoWeek');
      return new DateRange<D>(start, end);
    }

    return new DateRange<D>(null, null);
  }
}

@Component({
  selector: 'app-custom-date-picker',
  templateUrl: 'custom-date-picker.html',
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useFactory: (
        comp: DateRangePickerSelection,
        adapter: DateAdapter<unknown>
      ) => {
        return comp.selectionStrategy
          ? new WeekRangeSelectionStrategy(adapter)
          : null;
      },
      deps: [DateRangePickerSelection, DateAdapter],
    },
  ],
})
export class DateRangePickerSelection implements OnChanges {
  @Input() selectionStrategy: boolean = false;
  @Input() currentDateRange: { start: moment.Moment; end: moment.Moment };
  @Output() dateRangeChangeEvent = new EventEmitter();

  @ViewChild('picker') picker;

  public dateRange: FormGroup;

  constructor() {
    this.dateRange = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentDateRange && this.currentDateRange) {
      // Update the form controls with the current date range
      this.dateRange.patchValue({
        start: this.currentDateRange.start ? this.currentDateRange.start.toDate() : null,
        end: this.currentDateRange.end ? this.currentDateRange.end.toDate() : null,
      });
    }
  }

  open() {
    this.picker.open();
  }

  close() {
    this.picker.close();
  }

  dateRangeChange() {
    this.dateRangeChangeEvent.emit(this.dateRange.value);
  }
}
